var module;
// LICENSE_CODE ZON
'use strict'; /*jslint node:true, react:true*/

var is_node = typeof module == 'object' && module.exports;
if (is_node) ;else ;
define(['/util/etask.js', 'hola_opt', '/www/hola/pub/util.js'], (etask, hopt, hola_util) => {
  var E = {};
  var _ref = hopt.recaptcha || {},
    v = _ref.v,
    enable = _ref.enable,
    site_key = _ref.site_key,
    _ref$domain = _ref.domain,
    domain = _ref$domain === void 0 ? 'www.google.com' : _ref$domain;
  var script_url = `https://${domain}/recaptcha/api.js?` + `render=${v == 2 ? 'explicit' : site_key}&onload=recaptcha_onload`;
  window.hola_recaptcha = {
    loaded: false,
    load_et: null,
    token_et: null
  };
  window.recaptcha_onload = () => {
    window.hola_recaptcha.loaded = true;
    hola_util.perr({
      id: 'www_recaptcha_load'
    });
    if (window.hola_recaptcha.load_et) window.hola_recaptcha.load_et.continue();
  };
  E.load = () => window.hola_recaptcha.load_et || etask(function* () {
    if (!enable || window.hola_recaptcha.loaded) return;
    window.hola_recaptcha.load_et = this;
    this.finally(() => window.hola_recaptcha.load_et = null);
    var script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = script_url;
    script.async = true;
    script.defer = true;
    script.onerror = () => {
      hola_util.perr({
        id: 'www_google_recapthca_load_error'
      });
      E.load_error = true;
    };
    document.head.appendChild(script);
    yield this.wait();
  });
  E.unload = () => {
    window.hola_recaptcha.loaded = false;
    if (window.hola_recaptcha.load_et) window.hola_recaptcha.load_et.return();
    if (window.hola_recaptcha.token_et) window.hola_recaptcha.token_et.return();
    var badge = document.querySelector('.grecaptcha-badge');
    if (badge) badge.remove();
    var script = document.querySelector(`script[src="${script_url}"]`);
    if (script) script.remove();
    stop_observer();
    challenge_cb = null;
  };
  E.render = (el, _challenge_cb) => etask(function* () {
    if (!enable) return;
    if (!window.hola_recaptcha.loaded) yield E.load();
    if (v == 3) return;
    challenge_cb = _challenge_cb;
    window.grecaptcha.render(el, {
      sitekey: site_key,
      size: 'invisible',
      callback: token => window.hola_recaptcha.token_et.return(token)
    });
  });
  E.new_token = action => etask(function* () {
    if (!enable) return;
    window.hola_recaptcha.token_et = this;
    this.finally(() => {
      window.hola_recaptcha.token_et = null;
      stop_observer();
    });
    if (!window.hola_recaptcha.loaded) yield E.load();
    // can happen if load was canceled
    if (!window.hola_recaptcha.loaded) return;
    if (v == 3) {
      window.grecaptcha.execute(site_key, {
        action
      }).then(token => this.return(token));
    } else {
      start_observer(action);
      window.grecaptcha.reset();
      window.grecaptcha.execute();
    }
    yield this.wait();
  });
  var observer,
    challenge_cb,
    challenge_visible = false;
  var start_observer = action => {
    if (!window.MutationObserver) return;
    observer = new MutationObserver(() => {
      var iframe = document.body.querySelector('iframe[title*="recaptcha"]');
      if (!iframe) return;
      var visible = getComputedStyle(iframe).visibility == 'visible';
      if (visible == challenge_visible) return;
      if (visible && !challenge_visible && challenge_cb) challenge_cb(action);
      if (!visible && challenge_visible && window.hola_recaptcha.token_et) window.hola_recaptcha.token_et.throw('recaptcha_cancel');
      challenge_visible = visible;
    });
    observer.observe(document.body, {
      childList: true,
      attributes: true,
      attributeOldValue: false,
      characterData: false,
      characterDataOldValue: false,
      subtree: true
    });
  };
  var stop_observer = () => {
    if (!observer) return;
    challenge_visible = false;
    observer.disconnect();
    observer = null;
  };
  return E;
});